var $c1545fe26f1d3e20$exports = {};
$c1545fe26f1d3e20$exports = {
    "loading": `\u{8F09}\u{5165}\u{4E2D}\u{2026}`,
    "loadingMore": `\u{6B63}\u{5728}\u{8F09}\u{5165}\u{66F4}\u{591A}\u{2026}`
};


export {$c1545fe26f1d3e20$exports as default};
//# sourceMappingURL=zh-TW.module.js.map
